

import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'

export default function CircleArrowDownIcon(props) {
    const { style, color } = props;
    const classes = useStyles({color, ...props})()

    return(
        <svg className={classes.container}  style={style} width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M21 10.5C21 16.2897 16.2897 21 10.5 21C4.7103 21 -7.12045e-07 16.2897 -4.5897e-07 10.5C-2.05894e-07 4.7103 4.7103 -7.12045e-07 10.5 -4.5897e-07C16.2897 -2.05894e-07 21 4.7103 21 10.5ZM19.425 10.5C19.425 5.57865 15.4213 1.575 10.5 1.575C5.57865 1.575 1.575 5.57865 1.575 10.5C1.575 15.4213 5.57865 19.425 10.5 19.425C15.4213 19.425 19.425 15.4213 19.425 10.5ZM14.7024 9.54198L11.0579 13.2023C10.9098 13.3503 10.7093 13.4333 10.5003 13.4333C10.2903 13.4333 10.0898 13.3503 9.94171 13.2023L6.29821 9.54198C6.14492 9.38868 6.06826 9.18708 6.06826 8.98653C6.06826 8.78493 6.14492 8.58228 6.30032 8.42898C6.60902 8.12238 7.10671 8.12343 7.41332 8.43108L10.5003 11.5307L13.5863 8.43108C13.8929 8.12343 14.3916 8.12238 14.7003 8.42898C15.0101 8.73558 15.008 9.23328 14.7024 9.54198Z" />
        </svg>
    )
}


const useStyles = ({color, ...props}) => makeStyles((theme) => ({
    container:{
        '& path': {
            fill: color ? color : theme.palette.primary.main,
            width: props.width,
         },
    }
}));